<template>
    <div class="container-name">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <h2 class="text-white">Create an email</h2>
                <p class="p-text" style="font-size:17px; color: black">Keep your subscribers engaged by sharing your latest news, <br> promoting a line of products, or announcing an event.
                </p> 
                <form  @submit.prevent="onBegin">
                    <div class="form-group">
                        <input type="text" class="form-input" name="email" id="email" placeholder="Company's Name"/>
                    </div>
                    <div class="form-group">
                        <button class="form-submit" id="submit"> 
                            Begin
                            <i class="fa fa-arrow-right"></i>
                        </button>
                        <!-- <input type="submit" name="submit" id="submit" class="form-submit " value="Continue "/> -->
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },

    methods:{
        onBegin(){
            this.$router.replace({name:'draft'})
            console.log('jsohua')
        }
    }
}
</script>

<style lang="css" scoped>
.form-input {
  width: 100%;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  -o-border-radius: 5px;
  -ms-border-radius: 5px;
  padding: 17px 20px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  color: #222; 
}
.form-submit {
    width: 50%;
    border-radius: 5px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    -o-border-radius: 5px;
    -ms-border-radius: 5px;
    padding: 17px 20px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    border: none;
    /* background-image: -moz-linear-gradient(to left, #74ebd5, #9face6);*/
    background-image: -ms-linear-gradient(to left, #74ebd5, #9face6); 
    background-image: -o-linear-gradient(to left, #74ebd5, #9face6);
    background-image: -webkit-linear-gradient(to left, #74ebd5, #9face6);
    background-image: linear-gradient(to left, #0085A1, #0fabca); 
  }
p{
    text-align: white !important;
}
</style>